<div class="points-summary-bar d-flex justify-content-between d-lg-none">
  <!-- Back Button -->
  <div class="back-btn text-danger cursor-pointer d-flex align-items-center d-lg-none" [routerLink]="[backButtonLink]">
    <span class="material-icons"> chevron_left </span>
    <span class="font-size-14 fw-bold">{{ 'rewards.back.to.raffles' | translate }}</span>
  </div>
</div>
